export default "__VITE_ASSET__CJ8x8fvK__"